import { apiClient } from 'modules/core/lib/mobx-rest'
import { Collection } from 'modules/core/lib/mobx-rest'

import Assignment from 'modules/complaints/store/models/Assignment'

type UpsertParams = {
  access_ids: string[]
}
export class Assignments extends Collection<Assignment> {
  get cacheKey(): string {
    return 'assignments'
  }

  model() {
    return Assignment
  }

  async upsert(params: UpsertParams) {
    const newData = await apiClient().put(this.upsertRoute(), params)

    if (Array.isArray(newData)) this.set(newData)

    return newData
  }

  private upsertRoute() {
    return this.model().urlRoot() + '/upsert'
  }
}
